import { render, staticRenderFns } from "./PrivateNote.vue?vue&type=template&id=0c2c63b2"
import script from "./PrivateNote.vue?vue&type=script&lang=js"
export * from "./PrivateNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports